import * as React from 'react';
import styled from 'styled-components';

import { useLanguage } from 'core/hooks';
import { AppLanguage } from 'core/state/languageState';

const LANGUAGES: AppLanguage[] = ['ru', 'pl'];

/** Compact RU / PL toggle for the menu — switches the UI language at runtime. */
export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <Group>
      {LANGUAGES.map((lang) => (
        <LangButton
          key={lang}
          type="button"
          isActive={language === lang}
          onClick={() => setLanguage(lang)}
        >
          {lang.toUpperCase()}
        </LangButton>
      ))}
    </Group>
  );
};

const Group = styled.div`
  display: flex;
  border: 1px solid var(--k-border-dfe6f1);
  border-radius: 6px;
  overflow: hidden;
`;

const LangButton = styled.button<{ isActive: boolean }>`
  border: none;
  cursor: pointer;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ isActive }) =>
    isActive ? 'var(--k-bg-0d53fc)' : 'var(--k-bg-ffffff)'};
  color: ${({ isActive }) =>
    isActive ? 'var(--k-fg-ffffff)' : 'var(--k-fg-616e78)'};

  &:not(:last-child) {
    border-right: 1px solid var(--k-border-dfe6f1);
  }
`;
